var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 19v-1a1 1 0 10-2 0 1 1 0 100 2h1a1 1 0 001-1m-7.5-8a1.5 1.5 0 100 3 1.5 1.5 0 000-3m-5-5a1.5 1.5 0 100 3 1.5 1.5 0 000-3m.2 7.7l6-6a1 1 0 10-1.4-1.4l-6 6a1 1 0 101.4 1.4M20 8V6a1 1 0 10-2 0v2a1 1 0 102 0m0 6v-2a1 1 0 10-2 0v2a1 1 0 102 0M2 8V6a1 1 0 00-2 0v2a1 1 0 002 0m0 6v-2a1 1 0 10-2 0v2a1 1 0 102 0m1 5a1 1 0 00-1-1 1 1 0 10-2 0v1a1 1 0 001 1h1a1 1 0 001-1M20 2V1a1 1 0 00-1-1h-1a1 1 0 100 2 1 1 0 102 0m-5 17a1 1 0 00-1-1h-2a1 1 0 100 2h2a1 1 0 001-1m-6 0a1 1 0 00-1-1H6a1 1 0 100 2h2a1 1 0 001-1m6-18a1 1 0 00-1-1h-2a1 1 0 100 2h2a1 1 0 001-1M9 1a1 1 0 00-1-1H6a1 1 0 000 2h2a1 1 0 001-1M1 3a1 1 0 01-1-1V1a1 1 0 011-1h1a1 1 0 010 2 1 1 0 01-1 1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.68abb75d.svg";
export { ForwardRef as ReactComponent };